<template>
  <div>
    <b-overlay :show="!loaded" opacity="0.4">
      <div>
        <div v-if="this.loaded && this.devices.length === 0">
          <div class="alert alert-primary" role="alert">
            دستگاهی یافت نشد، پس از خرید دستگاه با توجه به راهنمای دستگاه آن را
            به پنل خود اضافه کنید.
          </div>
        </div>
      </div>

      <div
        class="d-flex flex-wrap justify-content-center justify-content-md-start"
      >
        <div
          v-for="device in devices"
          style="min-width: 145px; max-width: 155px"
          :key="device.id"
          class="card card-custom m-2 text-center"
        >
          <router-link
            :to="{ name: 'devices-show', params: { id: device.id } }"
          >
            <div class="card-body p-4">
              <div class="symbol symbol-50 text-center">
                <img
                  class="mx-auto"
                  :alt="device.name"
                  :src="`/media/devices/${device.type}.png`"
                />
              </div>
              <div class="mt-4 font-size-sm">
                {{ device.name }}
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </b-overlay>

    <div class="overflow-auto mt-5" v-if="devicesPagination.lastPage > 1">
      <b-pagination
        v-model="devicesPagination.currentPage"
        :total-rows="devicesPagination.total"
        :per-page="devicesPagination.perPage"
        aria-controls="my-table"
        @input="getDevices()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_DEVICES } from "@/core/services/store/devices.module";
import { mapGetters } from "vuex";

export default {
  name: "dashboard",
  components: {},
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.getDevices().then(() => {
      this.setBreadcrumbs();
      this.setActions();
    });
  },
  computed: {
    ...mapGetters(["devices", "devicesPagination"])
  },
  methods: {
    setBreadcrumbs() {
      let items = [];

      if (this.$route.query.user) {
        items.push({
          title: "مدیریت",
          route: { name: "admin-dashboard" }
        });

        items.push({ title: "کاربران", route: { name: "admin-users-show" } });

        items.push({
          title: this.$route.query.user,
          route: {
            name: "admin-users-show",
            params: { id: this.$route.query.user }
          }
        });

        items.push({ title: "دستگاه ها" });
      } else {
        items.push({ title: "دستگاه ها" });
      }

      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    setActions() {
      let links = [];

      links.push({
        name: "اطلاعات",
        to: {
          name: "devices-details",
          params: { id: this.$route.params.id },
          query: this.$route.query
        }
      });

      if (this.$route.query.user) {
        links.push({
          name: "افزودن دستگاه",
          class: "btn-primary",
          to: {
            name: "admin-devices-devices-create",
            params: { id: this.$route.params.id },
            query: this.$route.query
          }
        });
      }

      this.$store.dispatch(SET_ACTIONS, {
        links: links
      });
    },
    getDevices() {
      return new Promise((resolve, reject) => {
        this.loaded = false;
        this.$store
          .dispatch(FETCH_DEVICES)
          .then(() => {
            this.loaded = true;
            resolve();
          })
          .catch(() => {
            this.loaded = true;
            reject();
          });
      });
    }
  }
};
</script>
